import {Component, OnInit, HostListener, ViewChild, ElementRef, AfterViewInit} from '@angular/core';
import {first} from 'rxjs/operators';

import {PatientService} from '../../services/patient.service';
import {AuthToken} from '../../models/authToken';
import {Patient} from '../../models/patient';

import {MessageService} from '../../services/message.service';
import {AlertService} from '../../services/alert.service';
import {DialogComponent} from '../../modules/change-password/dialog/dialog.component';
import {MatDialog, MatSelectChange} from '@angular/material';
import {ActivatedRoute, Router} from '@angular/router';
import {ViewTextesLegauxComponent} from '../../modules/textes-legaux/view-textes-legaux/view-textes-legaux.component';
import {FormGroup, FormBuilder} from '@angular/forms';
import {LoaderService} from '../../services/loader.service';
import {TrackingService} from '../../services/tracking.service';

import { DisclaimerService } from '../../services/disclaimer.service';
import {CompteService} from '../../services/compte.service';
import {StorageService} from '../../services/storage.service';
import { ParametersService } from 'src/app/services/parameters.service';
import { LocalStorageSettings } from 'src/app/services/app-config.service';

@Component({
    selector: 'oap-home',
    templateUrl: './home.component.html',
    styleUrls: ['./home.component.scss']
})
export class HomeComponent implements OnInit, AfterViewInit {
    @ViewChild('fileDocAutre')
    eltRefFileDocAutre: ElementRef;
    authToken: AuthToken;
    patients: Patient[];
    currentPatient: Patient;
    patientId: number;

    mapPatient: Map<number, Patient>;

    public files: Set<File> = new Set();

    mesCommandesForm: FormGroup;

    retUpload;
    public scrollOffsetY: number;
    public offset: number;
    public mobileUndefined = false;
    constructor(
        public dialog: MatDialog,
        private messageService: MessageService,
        private patientService: PatientService,
        private formBuilder: FormBuilder,
        private route: ActivatedRoute,
        private router: Router,
        private alertService: AlertService,
        private loaderService: LoaderService,
        private disclaimer: DisclaimerService,
        private tracking: TrackingService,
        private compteService: CompteService,
        private storageService: StorageService,
        private parameterService: ParametersService) {
          this.authToken = JSON.parse(localStorage.getItem('currentUser'));
          this.currentPatient = <Patient>({identifiantSAP: ''});
        }
    @HostListener('window:scroll', []) public scrolling() {
        const the_video = document.getElementById('my_video');
        const sticky_video = document.getElementById('sticky_video');

        if (sticky_video !== null) {
            this.scrollOffsetY = window.pageYOffset;
            this.offset = (the_video.offsetTop + sticky_video.offsetHeight) - window.innerHeight;
            this.scrollOffsetY >= this.offset ? sticky_video.className = 'sticky-right' : sticky_video.className = 'sticky-right sticky-visible';
        }
    }

    ngOnInit() {
        this.patientId = parseInt(JSON.parse(localStorage.getItem('patientId')));
        const authToken = JSON.parse(localStorage.getItem('currentUser'));
        const typeCompte = authToken.type;
        if (typeCompte === 'A' ) {
            this.router.navigate(['/admin']);
        } else if (typeCompte === 'G' || typeCompte === 'T' || typeCompte === 'V') {
            this.router.navigate(['/backoffice']);
        }

        // this.loaderService.showLoader();
        this.messageService.sendMessage('page-home');
        this.mesCommandesForm = this.formBuilder.group({
            custumer_number: [''],
            surname: [''],
            firstname: [''],
            op: [''],
            form_id: ['']
        });

        this.tracking.DataLayer('/app', 'Homepage portail', '', '');
    }

    ngAfterViewInit() {
        /*
        if (this.patientId) {
            this.checkForDisplayModal();
        }*/
        this.storageService.watchPatientId().subscribe((patientId) => {
            this.patientId = patientId;
            this.checkForDisplayModal();
        });
        const compteExpire = JSON.parse(localStorage.getItem('compte-expire'));
        const validationCGU = JSON.parse(localStorage.getItem('validation-cgu'));
        if (compteExpire === 'true') {
            const dialogRef = this.dialog.open(DialogComponent,
                {
                    disableClose: true,
                    data: {expired: true}
                });
            localStorage.setItem('compte-expire', 'false');
        }
        if (validationCGU === 'true') {
            const dialogRef = this.dialog.open(ViewTextesLegauxComponent,
                {
                    disableClose: true,
                    data: {typeTexte: 'cgu'}
                });
            dialogRef.afterClosed().subscribe(result => {
                if (result) {
                    localStorage.setItem('validation-cgu', 'false');
                }
            });
        }
        setTimeout( () => {
            const sticky_video = document.getElementById('sticky_video');
            if (sticky_video !== null) {
                sticky_video.className = 'sticky-right sticky-visible';
            }
        }, 500 );

        this.parameterService.getDeliveryAvailable()
            .pipe(first())
            .subscribe(
                data => {
                    this.alertService.clear();
                    if (data !== null) {
                        //this.alertService.success(data.deliveryAvailable);
                        localStorage.setItem(LocalStorageSettings.LS_KEY_DELEVERY, data.deliveryAvailable);
                    }
                },
                error => {
                    console.error(error)
                    this.alertService.error(error, true);
                });
    }

    public changeSelectedPatient($event: MatSelectChange) {
        this.currentPatient = this.mapPatient.get($event.value);
    }

    public onSubmit(form: any, e: any): void {
        e.target.submit();
    }

    public openExternal(url: string) {
      this.disclaimer.openPopinExternal(url);
    }

    scroleTo(id) {
        document.getElementById(id).scrollIntoView();
    }

    public closeModalSante() {
        document.getElementById('modalSante').style.display = 'none';
        if (this.mobileUndefined) {
            document.getElementById('modalTel').style.display = 'block';
        }
    }

    public closeModalTel() {
        document.getElementById('modalTel').style.display = 'none';
    }

    checkForDisplayModal() {
        this.patientService.getPatient(this.patientId).subscribe((data) => {
            // tslint:disable-next-line:max-line-length
            let santeUndefined = false;
            if (data.numeroSecuriteSociale === null && (data.mutuelleCodePrefectoral === null && data.mutuelleDateFinDroit === null && data.mutuelleNumeroAdherent === null)) {
                if(document.getElementById('modalSante') !== null) {
                    document.getElementById('modalSante').style.display = 'block';
                    santeUndefined = true;
                }
            }
            this.compteService.checkMobileMissing(data.compteKey).subscribe((val: any) => {
                if (val.missingMobilePhoneNumber) {
                    this.mobileUndefined = true;
                    if (!santeUndefined) {
                        document.getElementById('modalTel').style.display = 'block';
                    }
                }
            });
        });
    }
}
